export default {"src":"/_next/static/image/public/img/TV_multiscreen.2f78e9b76929aebfb4f59e0947437705.svg","height":192,"width":192};